"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightTabDate = void 0;
const moment_1 = require("moment");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const dateTimeFormat_1 = require("../../../utils/dateTimeFormat");
const weekdaysTranslations = {
    1: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Tabs/Flight/Date:Mo', defaultMessage: 'Mo' })),
    2: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Tabs/Flight/Date:Tu', defaultMessage: 'Tu' })),
    3: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Tabs/Flight/Date:We', defaultMessage: 'We' })),
    4: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Tabs/Flight/Date:Th', defaultMessage: 'Th' })),
    5: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Tabs/Flight/Date:Fr', defaultMessage: 'Fr' })),
    6: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Tabs/Flight/Date:Sa', defaultMessage: 'Sa' })),
    7: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Tabs/Flight/Date:Su', defaultMessage: 'Su' })),
};
const FlightTabDate = (props) => {
    const { date, className } = props;
    if (!(0, moment_1.isMoment)(date)) {
        return (react_1.default.createElement("div", { className: className }, date));
    }
    const weekday = date.isoWeekday();
    return (react_1.default.createElement("div", { className: className },
        weekdaysTranslations[weekday],
        ' - ',
        date.format(dateTimeFormat_1.DATE_FORMAT)));
};
exports.FlightTabDate = FlightTabDate;
//# sourceMappingURL=Date.js.map